var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tabs"},_vm._l((_vm.items),function(item){return _c('a',{key:item.label,staticClass:"c-tab",class:{ 'c-tab--active': item.isSelected },attrs:{"href":"#"}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }